module.exports = __webpack_public_path__ + "img/icon5.18e2cf12.png";